// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.ViewPassRequest_modalOverlay__\\+7RZY {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  z-index: 1300;
  animation: ViewPassRequest_fadeIn__F3\\+Fs 0.3s ease-out;
}

/* Modal Content */
.ViewPassRequest_modalContent__9dwt- {
  width: 40%;
  max-width: 700px;
  min-width: 500px;
  background-color: white;
  height: 100vh;
  overflow-y: auto;
  padding-bottom: 0px;
  position: relative;
  animation: ViewPassRequest_slideInRight__AXnfQ 0.3s ease-out;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  border-radius: 16px 0 0 0px;
}

.ViewPassRequest_rejectedBy__L0t97 {
  background-color: #fee2e2;
}

.ViewPassRequest_approvedBy__Z3WNu {
  background-color: #dcfce7;
}

.ViewPassRequest_remarkParent__Qbf4n {
  margin: 16px 24px;
  padding: 16px 24px;
  border-radius: 16px;
  border: 1px solid var(--Slate-200, #e2e8f0);
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin-bottom: 30px;
}

/* Slide Animation */
@keyframes ViewPassRequest_slideInRight__AXnfQ {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes ViewPassRequest_fadeIn__F3\\+Fs {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Header */
.ViewPassRequest_modalHeader__50xjJ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.ViewPassRequest_modalTitle__JxPBo {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  font-family: 'Inter', sans-serif;
}
.ViewPassRequest_statusSection__tcVBp {
  display: flex;
  gap: 12px;
  align-items: center;
}

.ViewPassRequest_headerRight__BdCHy {
  display: flex;
  align-items: center;
  gap: 16px;
}

.ViewPassRequest_statusChip__bJzL9 {
  font-weight: 600;
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
  font-size: 12px;
  padding: 4px 12px;
  text-transform: capitalize;
}

.ViewPassRequest_closeButton__wq1Iv {
  color: #6b7280;
  transition: all 0.2s ease;
}

.ViewPassRequest_closeButton__wq1Iv:hover {
  color: #374151;
  background-color: #f3f4f6;
}

/* Student Overview Section */
.ViewPassRequest_studentOverview__W-jJc {
  padding: 24px;
}

.ViewPassRequest_avatarSection__j8FtP {
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background: var(--Violet-50, #f5f3ff);
  padding: 12px 16px;
}

.ViewPassRequest_studentAvatar__sfUPE {
  width: 32px;
  height: 32px;
  color: var(--Gray-800, #1f2937);
  text-align: center;

  /* Inter/Body small/Body small - semibold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
}

.ViewPassRequest_studentInfo__KvY5h {
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* min-width: 290px; */
  width: 100%;
  justify-content: space-between;
  /* gap: 20px; */
}

.ViewPassRequest_studentInfoBottom__Vt080 {
  display: flex;

  gap: 24px;
  margin-top: 6px;
}

.ViewPassRequest_studentName__QxBy7 {
  color: var(--Gray-800, #1f2937);

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  font-family: 'Inter', sans-serif;
}

.ViewPassRequest_studentEmail__eme1C,
.ViewPassRequest_studentMobile__FXVgj {
  font-size: 14px;
  color: #6b7280;
  font-family: 'Inter', sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ViewPassRequest_studentEmail__eme1C svg,
.ViewPassRequest_studentMobile__FXVgj svg {
  flex-shrink: 0;
}

/* Details Section */
.ViewPassRequest_detailsSection__Qxh30 {
  margin: 8px 24px;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid var(--Slate-200, #e2e8f0);
}

.ViewPassRequest_sectionHeader__MD5G0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ViewPassRequest_sectionTitle__Z\\+7xU {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  font-family: 'Inter', sans-serif;
}

.ViewPassRequest_relocateButton__7YcI6 {
  color: var(--Violet, #644ee5);
  text-align: center;

  /* Inter/Body small/Body small - medium */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
  background-color: #f5f3ff;
  border: 1px solid var(--Violet-200, #c7d2fe);
  border-radius: 8px;
  border: 1px solid var(--Violet, #644ee5);
  box-shadow: none !important;
}

.ViewPassRequest_relocateButton__7YcI6:hover {
  background-color: #644ee5;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: none;
}

/* Details Grid */
.ViewPassRequest_detailsGrid__9mSSh {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 12px;
}

.ViewPassRequest_detailItem__ijzhK {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
  padding: 12px 0;
  /* width: 289px; */
}

.ViewPassRequest_detailItem__ijzhK:last-child {
  border-bottom: none;
}

.ViewPassRequest_detailLabel__DHK6n {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
}

.ViewPassRequest_detailItem2__Fgapi {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.ViewPassRequest_horizintalRule__7wni8 {
  border-bottom: 0.5px solid #d1d5db;
  width: 100%;
  margin-bottom: 16px;
}

.ViewPassRequest_detailDescription__iK6MH {
  width: 100%;
}
.ViewPassRequest_detailValue__f0c8O {
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
  line-height: 20px;
  font-family: 'Inter', sans-serif;
}
.ViewPassRequest_attachmentContainer__jrve9 {
  width: 100%;

  border-radius: 12px;
  background: #f1eeff;
  display: flex;
  min-width: 175px;
  padding: 12px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  display: flex;
  align-items: center;
  margin-top: 6px;
}

.ViewPassRequest_detailsNameGrid__pBoHX {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Action Button Container - NEW STYLES ONLY */
.ViewPassRequest_actionButtonContainer__vBSdy {
  padding: 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  display: flex;
  justify-content: flex-end;
}

.ViewPassRequest_resolveButton__mHZC4 {
  background-color: #644ee5 !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-family: 'Inter', sans-serif !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  gap: 6px !important;
  align-items: center !important;
  white-space: nowrap !important;
  box-shadow: none !important;
}

.ViewPassRequest_resolveButton__mHZC4:hover {
  background-color: #533ec9 !important;
  box-shadow: 0 4px 12px rgba(100, 78, 229, 0.3) !important;
}

.ViewPassRequest_detailsGrid2__GqnUE {
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
}

.ViewPassRequest_approvalGrid__oh64V {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.ViewPassRequest_approvalCard__1JV0z {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  background-color: #fafafa;
}

.ViewPassRequest_approvalTitle__Ws-8G {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.ViewPassRequest_approvalItem__H77Ay {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 0;
}

/* Actions Container - Sticky Bottom */
.ViewPassRequest_actionsContainer__5jTuo {
  position: sticky;
  bottom: 0;
  margin-top: auto;
  width: 100%;
  padding: 16px 24px;
  background-color: white;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
}

.ViewPassRequest_rejectBtn__GnwGo {
  color: white !important;
  background-color: #ef4444 !important;
  font-weight: 600 !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-family: 'Inter', sans-serif !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  gap: 6px !important;
  align-items: center !important;
  white-space: nowrap !important;
  box-shadow: none !important;
}

.ViewPassRequest_rejectBtn__GnwGo:hover {
  background-color: #dc2626 !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
}

.ViewPassRequest_attachmentWrapper__dOAVV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.ViewPassRequest_attachmentIcon__c5\\+At {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-block;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .ViewPassRequest_modalContent__9dwt- {
    width: 50%;
    /* min-width: 350px; */
  }
}

@media (max-width: 768px) {
  .ViewPassRequest_modalContent__9dwt- {
    width: 100%;
    min-width: 100%;
  }

  .ViewPassRequest_modalHeader__50xjJ {
    padding: 20px 20px 16px 20px;
  }

  .ViewPassRequest_studentOverview__W-jJc,
  .ViewPassRequest_detailsSection__Qxh30 {
    padding: 20px;
  }

  .ViewPassRequest_approvalGrid__oh64V {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .ViewPassRequest_modalHeader__50xjJ {
    padding: 16px 16px 12px 16px;
  }

  .ViewPassRequest_studentOverview__W-jJc,
  .ViewPassRequest_detailsSection__Qxh30 {
    padding: 16px;
  }

  .ViewPassRequest_modalTitle__JxPBo {
    font-size: 20px;
  }

  .ViewPassRequest_sectionTitle__Z\\+7xU {
    font-size: 16px;
  }

  .ViewPassRequest_studentName__QxBy7 {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperMostAdmin/GatePass/components/ViewPassRequest.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,uDAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,4DAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;;EAElB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;;EAEb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;;EAE/B,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;;EAElB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,WAAW;;EAEX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,2CAA2C;EAC3C,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,2CAA2C;EAC3C,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Modal Overlay */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n  z-index: 1300;\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Modal Content */\n.modalContent {\n  width: 40%;\n  max-width: 700px;\n  min-width: 500px;\n  background-color: white;\n  height: 100vh;\n  overflow-y: auto;\n  padding-bottom: 0px;\n  position: relative;\n  animation: slideInRight 0.3s ease-out;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px 0 0 0px;\n}\n\n.rejectedBy {\n  background-color: #fee2e2;\n}\n\n.approvedBy {\n  background-color: #dcfce7;\n}\n\n.remarkParent {\n  margin: 16px 24px;\n  padding: 16px 24px;\n  border-radius: 16px;\n  border: 1px solid var(--Slate-200, #e2e8f0);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n/* Slide Animation */\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Header */\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n}\n\n.modalTitle {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1f2937;\n  font-family: 'Inter', sans-serif;\n}\n.statusSection {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.headerRight {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.statusChip {\n  font-weight: 600;\n  /* text-transform: uppercase; */\n  letter-spacing: 0.5px;\n  font-size: 12px;\n  padding: 4px 12px;\n  text-transform: capitalize;\n}\n\n.closeButton {\n  color: #6b7280;\n  transition: all 0.2s ease;\n}\n\n.closeButton:hover {\n  color: #374151;\n  background-color: #f3f4f6;\n}\n\n/* Student Overview Section */\n.studentOverview {\n  padding: 24px;\n}\n\n.avatarSection {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border-radius: 8px;\n  background: var(--Violet-50, #f5f3ff);\n  padding: 12px 16px;\n}\n\n.studentAvatar {\n  width: 32px;\n  height: 32px;\n  color: var(--Gray-800, #1f2937);\n  text-align: center;\n\n  /* Inter/Body small/Body small - semibold */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 142.857% */\n}\n\n.studentInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  /* min-width: 290px; */\n  width: 100%;\n  justify-content: space-between;\n  /* gap: 20px; */\n}\n\n.studentInfoBottom {\n  display: flex;\n\n  gap: 24px;\n  margin-top: 6px;\n}\n\n.studentName {\n  color: var(--Gray-800, #1f2937);\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  font-family: 'Inter', sans-serif;\n}\n\n.studentEmail,\n.studentMobile {\n  font-size: 14px;\n  color: #6b7280;\n  font-family: 'Inter', sans-serif;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.studentEmail svg,\n.studentMobile svg {\n  flex-shrink: 0;\n}\n\n/* Details Section */\n.detailsSection {\n  margin: 8px 24px;\n  padding: 24px;\n  border-radius: 16px;\n  border: 1px solid var(--Slate-200, #e2e8f0);\n}\n\n.sectionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  font-family: 'Inter', sans-serif;\n}\n\n.relocateButton {\n  color: var(--Violet, #644ee5);\n  text-align: center;\n\n  /* Inter/Body small/Body small - medium */\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  padding: 8px 16px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  background-color: #f5f3ff;\n  border: 1px solid var(--Violet-200, #c7d2fe);\n  border-radius: 8px;\n  border: 1px solid var(--Violet, #644ee5);\n  box-shadow: none !important;\n}\n\n.relocateButton:hover {\n  background-color: #644ee5;\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: none;\n}\n\n/* Details Grid */\n.detailsGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.detailItem {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 6px;\n  padding: 12px 0;\n  /* width: 289px; */\n}\n\n.detailItem:last-child {\n  border-bottom: none;\n}\n\n.detailLabel {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 400;\n  font-family: 'Inter', sans-serif;\n}\n\n.detailItem2 {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.horizintalRule {\n  border-bottom: 0.5px solid #d1d5db;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.detailDescription {\n  width: 100%;\n}\n.detailValue {\n  font-size: 14px;\n  color: #1f2937;\n  font-weight: 500;\n  line-height: 20px;\n  font-family: 'Inter', sans-serif;\n}\n.attachmentContainer {\n  width: 100%;\n\n  border-radius: 12px;\n  background: #f1eeff;\n  display: flex;\n  min-width: 175px;\n  padding: 12px 20px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n}\n\n.detailsNameGrid {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Action Button Container - NEW STYLES ONLY */\n.actionButtonContainer {\n  padding: 24px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.resolveButton {\n  background-color: #644ee5 !important;\n  color: white !important;\n  font-weight: 600 !important;\n  padding: 8px 16px !important;\n  border-radius: 8px !important;\n  text-transform: none !important;\n  font-size: 14px !important;\n  font-family: 'Inter', sans-serif !important;\n  transition: all 0.2s ease !important;\n  display: flex !important;\n  gap: 6px !important;\n  align-items: center !important;\n  white-space: nowrap !important;\n  box-shadow: none !important;\n}\n\n.resolveButton:hover {\n  background-color: #533ec9 !important;\n  box-shadow: 0 4px 12px rgba(100, 78, 229, 0.3) !important;\n}\n\n.detailsGrid2 {\n  display: grid !important;\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.approvalGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.approvalCard {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px;\n  background-color: #fafafa;\n}\n\n.approvalTitle {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 8px;\n}\n\n.approvalItem {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 6px 0;\n}\n\n/* Actions Container - Sticky Bottom */\n.actionsContainer {\n  position: sticky;\n  bottom: 0;\n  margin-top: auto;\n  width: 100%;\n  padding: 16px 24px;\n  background-color: white;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 10;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);\n}\n\n.rejectBtn {\n  color: white !important;\n  background-color: #ef4444 !important;\n  font-weight: 600 !important;\n  padding: 8px 16px !important;\n  border-radius: 8px !important;\n  text-transform: none !important;\n  font-size: 14px !important;\n  font-family: 'Inter', sans-serif !important;\n  transition: all 0.2s ease !important;\n  display: flex !important;\n  gap: 6px !important;\n  align-items: center !important;\n  white-space: nowrap !important;\n  box-shadow: none !important;\n}\n\n.rejectBtn:hover {\n  background-color: #dc2626 !important;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;\n}\n\n.attachmentWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.attachmentIcon {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: inline-block;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .modalContent {\n    width: 50%;\n    /* min-width: 350px; */\n  }\n}\n\n@media (max-width: 768px) {\n  .modalContent {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  .modalHeader {\n    padding: 20px 20px 16px 20px;\n  }\n\n  .studentOverview,\n  .detailsSection {\n    padding: 20px;\n  }\n\n  .approvalGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .modalHeader {\n    padding: 16px 16px 12px 16px;\n  }\n\n  .studentOverview,\n  .detailsSection {\n    padding: 16px;\n  }\n\n  .modalTitle {\n    font-size: 20px;\n  }\n\n  .sectionTitle {\n    font-size: 16px;\n  }\n\n  .studentName {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `ViewPassRequest_modalOverlay__+7RZY`,
	"fadeIn": `ViewPassRequest_fadeIn__F3+Fs`,
	"modalContent": `ViewPassRequest_modalContent__9dwt-`,
	"slideInRight": `ViewPassRequest_slideInRight__AXnfQ`,
	"rejectedBy": `ViewPassRequest_rejectedBy__L0t97`,
	"approvedBy": `ViewPassRequest_approvedBy__Z3WNu`,
	"remarkParent": `ViewPassRequest_remarkParent__Qbf4n`,
	"modalHeader": `ViewPassRequest_modalHeader__50xjJ`,
	"modalTitle": `ViewPassRequest_modalTitle__JxPBo`,
	"statusSection": `ViewPassRequest_statusSection__tcVBp`,
	"headerRight": `ViewPassRequest_headerRight__BdCHy`,
	"statusChip": `ViewPassRequest_statusChip__bJzL9`,
	"closeButton": `ViewPassRequest_closeButton__wq1Iv`,
	"studentOverview": `ViewPassRequest_studentOverview__W-jJc`,
	"avatarSection": `ViewPassRequest_avatarSection__j8FtP`,
	"studentAvatar": `ViewPassRequest_studentAvatar__sfUPE`,
	"studentInfo": `ViewPassRequest_studentInfo__KvY5h`,
	"studentInfoBottom": `ViewPassRequest_studentInfoBottom__Vt080`,
	"studentName": `ViewPassRequest_studentName__QxBy7`,
	"studentEmail": `ViewPassRequest_studentEmail__eme1C`,
	"studentMobile": `ViewPassRequest_studentMobile__FXVgj`,
	"detailsSection": `ViewPassRequest_detailsSection__Qxh30`,
	"sectionHeader": `ViewPassRequest_sectionHeader__MD5G0`,
	"sectionTitle": `ViewPassRequest_sectionTitle__Z+7xU`,
	"relocateButton": `ViewPassRequest_relocateButton__7YcI6`,
	"detailsGrid": `ViewPassRequest_detailsGrid__9mSSh`,
	"detailItem": `ViewPassRequest_detailItem__ijzhK`,
	"detailLabel": `ViewPassRequest_detailLabel__DHK6n`,
	"detailItem2": `ViewPassRequest_detailItem2__Fgapi`,
	"horizintalRule": `ViewPassRequest_horizintalRule__7wni8`,
	"detailDescription": `ViewPassRequest_detailDescription__iK6MH`,
	"detailValue": `ViewPassRequest_detailValue__f0c8O`,
	"attachmentContainer": `ViewPassRequest_attachmentContainer__jrve9`,
	"detailsNameGrid": `ViewPassRequest_detailsNameGrid__pBoHX`,
	"actionButtonContainer": `ViewPassRequest_actionButtonContainer__vBSdy`,
	"resolveButton": `ViewPassRequest_resolveButton__mHZC4`,
	"detailsGrid2": `ViewPassRequest_detailsGrid2__GqnUE`,
	"approvalGrid": `ViewPassRequest_approvalGrid__oh64V`,
	"approvalCard": `ViewPassRequest_approvalCard__1JV0z`,
	"approvalTitle": `ViewPassRequest_approvalTitle__Ws-8G`,
	"approvalItem": `ViewPassRequest_approvalItem__H77Ay`,
	"actionsContainer": `ViewPassRequest_actionsContainer__5jTuo`,
	"rejectBtn": `ViewPassRequest_rejectBtn__GnwGo`,
	"attachmentWrapper": `ViewPassRequest_attachmentWrapper__dOAVV`,
	"attachmentIcon": `ViewPassRequest_attachmentIcon__c5+At`
};
export default ___CSS_LOADER_EXPORT___;
